import React from "react";

const CartItem = ({ product, onRemove }) => {
    const { title, expiration_date, discounted_price, product_id, original_price, image_url } = product;

    // Нормализация даты
    const formattedDate = expiration_date

    console.log('cartItem formattedDate:', formattedDate);
    //TODO change this to image_url
    const imageSrc = '/images/default_food_logo.svg';

    return (
        <div className="cart-item">
            <div className="cart-item__image">
                <img src={imageSrc} alt={title}/>
            </div>
            <div className="cart-item__details">
                <h4 className="cart-item__title">{title}</h4>
                <p className="cart-item__expiration">Вжити до: {formattedDate || "Не вказано"}</p>
                <div className="cart-item__prices">
                    <span className="cart-item__original-price">{original_price} ₴</span>
                    <span className="cart-item__discounted-price">{discounted_price} ₴</span>
                </div>
            </div>
            <button
                className="cart-item__remove-btn"
                onClick={() => onRemove(product_id)}
            >
                <img src="/images/delete_button.svg" alt="Удалить"/>
            </button>
        </div>
    );
};

export default CartItem;
